module.exports = __webpack_public_path__ + "img/inncash-login-home-background-2026.a20c3333.webp";